<script>
export default {
  name: 'FormSponsorTexts',
  data() {
    return {};
  },
  props: {
    variant: {
      type: Number,
    }
  },
};
</script>

<template>
  <div class="text-center mt-10 sponsor-texts">
    <div v-if="this.variant < 0">
      Halteverbot123 ist exklusiver Partner von
      <br class="display_none xs-display-block" />
      <a href="https://www.halteverbot123.de/news-halteverbot123-ist-exklusiver-partner-von-sixt.html">
        <img class="ml-5" src="https://halteverbot123.de/files/upload/sixt/sixt_46x21.png" />
      </a>
      <a href="https://www.halteverbot123.de/starcar-autovermietung.html">
        <img
          style="height: 25px"
          class="ml-5"
          src="https://www.halteverbot123.de/files/upload/starcar-partner-of-halteverbot123.de.png"
        />
      </a>
      <br />
    </div>
    <span class="policy-text" v-if="!this.$store.getters.isMobile">
          Bei Nutzung dieser Seite, stimmen Sie den&nbsp;
          <a target="_blank" href="https://www.halteverbot123.de/datenschutz.html">
            Datenschutzbestimmungen
          </a>
          zu.
        </span>
  </div>
</template>
<style lang="scss"></style>
